import { render, staticRenderFns } from "./MyCkEditor.vue?vue&type=template&id=10587f42&scoped=true&"
import script from "./MyCkEditor.vue?vue&type=script&lang=js&"
export * from "./MyCkEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10587f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10587f42')) {
      api.createRecord('10587f42', component.options)
    } else {
      api.reload('10587f42', component.options)
    }
    module.hot.accept("./MyCkEditor.vue?vue&type=template&id=10587f42&scoped=true&", function () {
      api.rerender('10587f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyCkEditor.vue"
export default component.exports